import { getBaseUrl } from '@shared';

export function clientUserSignInLinkByEmail(
  clientEmail?: string,
  redirectTo: string = '/client/home',
): string {
  if (!clientEmail) return `${getBaseUrl()}/`;
  const params = new URLSearchParams({
    email: clientEmail,
    redirect_to: redirectTo,
  });
  return `${getBaseUrl()}/?${params.toString()}`;
}
